import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { captureMicrosoftReturn } from "./utils/microsoftSignIn";

// If this load is Microsoft sending the user back from sign-in, restore the
// address they left from before the router reads it.
captureMicrosoftReturn();

ReactDOM.render(<App />, document.getElementById("root"));

// Registered so the app can be installed to a phone's home screen and
// work offline. Note this comes with some pitfalls - deployed updates
// are only picked up on the next visit after all open tabs are closed.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();

// public/service-worker.js's notificationclick handler focuses this tab
// (if it's already open) rather than opening a second one, but focusing
// alone doesn't navigate anywhere - this is what actually takes the user
// to the event the notification was about. A full navigation (not
// history.push) since this runs entirely outside React Router - simpler
// than plumbing a history instance out to a module that isn't a React
// component, and this only fires on the comparatively rare "clicked a
// notification while the app happened to already be open" path.
if ("serviceWorker" in navigator) {
  navigator.serviceWorker.addEventListener("message", (event) => {
    if (event.data && event.data.type === "notification-click" && event.data.url) {
      window.location.href = event.data.url;
    }
  });
}
